// src/services/BankService.js
import {getNigerianBanks} from './api';
export class BankService {
    static CACHE_KEY = 'cached_banks_ng';
    static CACHE_DURATION = 12 * 60 * 60 * 1000; // 12 hours
  
    static async getBanksWithCache() {
      const cached = this.getFromCache();
      if (cached) {
        // console.log('📁 Using cached banks');
        return cached;
      }
  
      try {
        const response = await getNigerianBanks();
        
        if (response.success && response.banks) {
          const processedBanks = this.processBanks(response.banks);
          this.saveToCache(processedBanks);
          return processedBanks;
        }
      } catch (error) {
        // console.error('Bank fetch error:', error);
      }
  
      return [];
    }
  
    static processBanks(banks) {
      const uniqueBanks = new Map();
      
      banks.forEach(bank => {
        if (bank.active && 
            bank.currency === 'NGN' &&
            bank.supports_transfer === true &&
            bank.name && 
            bank.code) {
          const key = bank.id || bank.code;
          if (!uniqueBanks.has(key)) {
            uniqueBanks.set(key, {
              id: bank.id,
              name: bank.name,
              code: bank.code,
              longcode: bank.longcode,
              slug: bank.slug,
              supports_transfer: bank.supports_transfer,
              active: bank.active,
              type: bank.type
            });
          }
        }
      });
      
      return Array.from(uniqueBanks.values())
        .sort((a, b) => a.name.localeCompare(b.name));
    }
  
    static getFromCache() {
      try {
        const cached = localStorage.getItem(this.CACHE_KEY);
        if (!cached) return null;
        
        const { banks, timestamp } = JSON.parse(cached);
        
        if (Date.now() - timestamp < this.CACHE_DURATION) {
          return banks;
        }
        
        localStorage.removeItem(this.CACHE_KEY);
        return null;
      } catch (e) {
        return null;
      }
    }
  
    static saveToCache(banks) {
      localStorage.setItem(this.CACHE_KEY, JSON.stringify({
        banks,
        timestamp: Date.now()
      }));
    }
  
    static clearCache() {
      localStorage.removeItem(this.CACHE_KEY);
    }
  }